"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Th = exports.Td = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var dynamicStyles = function dynamicStyles(_ref) {
  var bordered = _ref.bordered,
      code = _ref.code;
  return (0, _objectSpread2.default)({}, bordered ? {
    border: '1px solid #ccc'
  } : {}, code ? {
    whiteSpace: 'nowrap',
    fontFamily: 'Monaco, Consolas, "Courier New", monospace'
  } : {});
};

var styles = {
  padding: '2px 6px'
};
var Td =
/*#__PURE__*/
(0, _styled.default)("td", {
  target: "e6fp4ir0"
})(styles, dynamicStyles);
exports.Td = Td;
var Th =
/*#__PURE__*/
(0, _styled.default)("th", {
  target: "e6fp4ir1"
})(styles, dynamicStyles);
exports.Th = Th;
Td.displayName = 'Td';
Th.displayName = 'Th';